import { Box, Button, Grid, Modal, Paper } from "@mui/material"
import { useModalContainerService } from "../../use-cases/modal-container"
import CloseIcon from '@mui/icons-material/Close';
import { useAppSelector } from "../hooks/store-hooks";

export const ModalContainer = () => {
  const modalContainer = useAppSelector((state) => state.modalContainer)
  const { closeModal } = useModalContainerService()
  return (
    <Modal
      open={modalContainer.open}
      onClose={() => {
        if (modalContainer.closeButton) {
          closeModal()
        }
      }}
    >
      <div>
        <Grid container alignItems={"center"} justifyContent="center">
          <Grid item>
            <Box p={2}>
              <Paper>
                <Box p={2} sx={{
                  position: 'absolute' as 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  bgcolor: 'background.paper',
                  border: '2px solid #000',
                  boxShadow: 24,
                  p: 4,
                }}>
                  
                  {modalContainer.closeButton && (
                    <Button 
                      onClick={() => closeModal()}
                      sx={{
                        position: 'absolute' as 'absolute',
                        top: '3%',
                        right: '3%',
                      }}
                    >
                      <CloseIcon />
                    </Button>

                  )}

                  {modalContainer.content}
                </Box>
              </Paper>
            </Box>
          </Grid>
        </Grid>

      </div>
    </Modal>


  )
}